import { menuList } from "../../model/appMenu";

const isHavingNoPermission = (obj) => {
  if (obj !== null && typeof obj !== "object") return false;
  const permissions = Object.values(obj);
  if (!Array.isArray(permissions)) return false;
  return permissions.every((permission) => permission === false);
};

const afterLoginPageHavePermission = (permissions) => {
  const roleBasedMenus = menuList["Manage"]
    .filter((menu) => permissions[menu.selector])
    .filter((menu) => permissions[menu.selector].view);
    const isAllTrue = (obj) => {
      if (!obj || typeof obj !== "object") return false;
      return Object.values(obj).every(value => value === true);
     };
    const apiDocFullAccess = isAllTrue(permissions.apiDocumentation);
   
  if (Array.isArray(roleBasedMenus) && roleBasedMenus?.length > 0 && roleBasedMenus[0].path !== "/insights") {
    if(apiDocFullAccess=== true){
    roleBasedMenus.unshift({
      name: "Shipments",
      path: "/shipments",
      selector: "shipments",
    });
   } else if (Array.isArray(roleBasedMenus) && roleBasedMenus?.length > 0 && roleBasedMenus?.some(menu => menu?.name === "Assets")) {
    roleBasedMenus.unshift({
      name: "Shipments",
      path: "/shipments",
      selector: "shipments",
    });
  }
  }
  return roleBasedMenus.length > 0 ? roleBasedMenus[0].path : null;
};

export { isHavingNoPermission, afterLoginPageHavePermission };
